import { render } from "./AddTaskComponent.vue?vue&type=template&id=23a75a73"
import script from "./AddTaskComponent.vue?vue&type=script&lang=js"
export * from "./AddTaskComponent.vue?vue&type=script&lang=js"
script.render = render

export default script